<template>
  <nav>
    <div class="container">
      <el-menu
        :default-active="$route.path"
        router
        class="el-menu-demo"
        mode="horizontal"
        active-text-color="#000"
      >
        <el-menu-item index="/"> <img src="../imgs/logo.png" alt="" class="logo"> </el-menu-item>
        <el-menu-item index="/home"><span slot="title">首页</span></el-menu-item>
        <el-menu-item index="/navigation"><span slot="title">网址导航</span></el-menu-item>
        <el-menu-item index="/config-assistant"><span slot="title">配置助手</span></el-menu-item>
        <el-menu-item index="/about"><span slot="title">关于我们</span></el-menu-item>
        <el-menu-item index="/join-us"><span slot="title">加入我们</span></el-menu-item>
        <el-menu-item>
          <a href="https://fishros.org.cn/" target="_blank" rel="noopener">社区</a>
        </el-menu-item>
        <div class="website-icons">
          <el-menu-item><a href="http://github.com/fishros/" target="_blank" rel="noopener"><span class="iconfont">&#xe8c6;</span></a></el-menu-item>
          <el-menu-item><a href="https://space.bilibili.com/1940177928" target="_blank" rel="noopener"><span class="iconfont">&#xeeac;</span></a></el-menu-item>
          <el-menu-item><a href="https://www.zhihu.com/people/fishros" target="_blank" rel="noopener"><span class="iconfont">&#xe64b;</span></a></el-menu-item>
        </div>
      </el-menu>
    </div>
  </nav>
</template>

<script>
export default {
  data () {
    return {
      activeIndex: 'logo',
      input: ''
    }
  },
  methods: {
    handleSelect (key, keyPath) {
    }
  }
}
</script>

<style scoped>
nav {
  background-color: #fff;
  margin-bottom: 30px;
  width: 100%;
}
.logo{
  height: 24px;
}

.container {
  width: 70%;
  margin: 0 auto;
}

.el-menu.el-menu--horizontal {
  border: 0;
  width: 100%;
}

.website-icons {
  float: right;
  display: flex;
}

.website-icons .el-menu-item {
  padding: 0;
  margin-left: 10px;
}

.el-menu-item a {
  display: inline-flex;
  align-items: center;
  height: 100%;
  color: inherit;
  text-decoration: none;
}
</style>
